import { cx, css } from "@emotion/css"
import { useState } from "react"

import Button from "@p-ban/common/src/components/html/Button"
import DropDown from "@p-ban/common/src/components/layout/DropDown"
import Arrow from "@p-ban/common/src/components/shape/Arrow"
import useHover from "@p-ban/common/src/hooks/useHover"

import listItemStyles from "./listItemStyle"

type Props = {
  title: string
  children: React.ReactElement
}

const Collapse = ({ title, children }: Props) => {
  const { isHovered, hoverProps } = useHover()
  const [show, set] = useState(false)

  const buttonClassName = cx(styles.button, listItemStyles.content, (show || isHovered) && listItemStyles.hover)

  return (
    <li {...hoverProps} className={listItemStyles.li}>
      <Button className={buttonClassName} hoverClassName={listItemStyles.hover} onClick={() => set((prev) => !prev)}>
        {title}
        <div className={styles.arrowContainer} style={{ transform: `translateY(${show ? 1 : -3}px)` }}>
          <Arrow direction={show ? "top" : "bottom"} />
        </div>
      </Button>
      <DropDown isOpen={show}>{children}</DropDown>
    </li>
  )
}

export default Collapse

const styles = {
  button: css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: transparent;
    border: none;
    outline-offset: -2px;
  `,
  arrowContainer: css`
    display: flex;
    align-items: center;
  `,
}
